export default __webpack_public_path__ + "static/media/Bei_dir_bin_ich_zu_Hause_Hoerprobe.956f63b0.mp3";